import { message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { Button } from 'components';
import { FormItem } from 'components/Form';
import Divider from 'containers/DriverPortalPage/components/Divider';
import DriverPortalLayout from 'containers/DriverPortalPage/components/DriverPortalLayout';
import HeaderPortal from 'containers/DriverPortalPage/MainPage/components/HeaderPortal';
import ReturnButton from 'containers/DriverPortalPage/MainPage/components/ReturnButton';
import UploadImageForm from 'containers/DriverPortalPage/MainPage/components/UploadImageForm';
import { FormikProps, FormikValues, useFormik } from 'formik';
import usePrompt from 'hooks/usePrompt';
import { useQueryParams } from 'hooks/useQueryParams';
import { useUpdateExpireDateImages } from 'hooks/useUpdateExpireDateImages';
import React, { useCallback, useEffect, useState } from 'react';
import {
  addressService,
  authenticationService,
  mainService,
  uploadService,
} from 'services/driverPortal';
import { STATUS_RESPONSE } from 'services/driverPortal/DriverPortal.interface';
import { getCurrentDate } from 'utils/dateUtils';
import * as Yup from 'yup';
import { isPdfFile } from '../../../../utils/isFilePdf';
import ConfirmReturnModal from '../components/ConfirmReturnModal';
import Information from '../components/Information';

export interface IVaccinationCertificatePageProps {}

interface IVaccinationCertificateImage {
  image?: string;
  createdAt?: string;
  isAllowConsent?: boolean;
}
interface IVaccinationCertificateRequest {
  document: IVaccinationCertificateImage;
  status?: string;
}

interface IVaccinationCertificateImageUpload {
  document?: FormData;
}

enum ImageTypes {
  DOCUMENT = 'document',
}

const imageKeys: ImageTypes[] = [ImageTypes.DOCUMENT];

const folderType = 'vaccination-certificate';

const validateVaccinationCertificate = Yup.object().shape({});

const VaccinationCertificatePage: React.FC<IVaccinationCertificatePageProps> = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const { search, pushUrl } = useQueryParams();
  const [disableEdit, setDisableEdit] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const { userId, accessToken } = authenticationService.getUserToken();
  const [imageDeletionFiles, setImageDeletionFiles] = useState<UploadFile[]>(
    [],
  );
  const [checkedBox, setCheckedBox] = useState(false);
  const [consentModal, setConsentModal] = useState<boolean | undefined>(
    undefined,
  );
  const { updateByFiles } = useUpdateExpireDateImages();
  const [, setShowPrompt] = usePrompt();
  const [formDirty, setFormDirty] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState<
    IVaccinationCertificateImageUpload
  >({});

  const [saveLoading, setSaveLoading] = React.useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [medicalFileName, setMedicalFileName] = useState<string>('');

  const goToMainPage = () => {
    pushUrl('/', search);
  };

  const goToLoginPage = () => {
    pushUrl('/login', search);
  };

  useEffect(() => {
    const { accessToken } = authenticationService.getUserToken() || {};
    if (!accessToken) {
      pushUrl('/login', search);
    }
  }, [pushUrl, search]);

  const uploadImage = async (
    files: IVaccinationCertificateImageUpload,
    key: ImageTypes,
    formValues: IVaccinationCertificateRequest,
    createdAt: string,
    isAllowConsent: boolean,
  ) => {
    const uploadFile = files[key] || null;

    if (uploadFile) {
      const response = await uploadService.uploadFile(uploadFile);

      if (response.data) {
        formValues[key] = {
          image: response.data[0],
          createdAt,
          isAllowConsent,
        };
      }
    }
  };

  const loadImage = async (path: string) => {
    try {
      const response = await mainService.loadImageAxios(path);
      return response;
    } catch (e) {
      return null;
    }
  };

  const buildPayloadMedCer = async (values: IVaccinationCertificateRequest) => {
    const f = values ?? {};

    const fd = new FormData();
    fd.append('tab', 'medical_certificate');
    if (filesToUpload.document?.get('files')) {
      fd.append(
        'medicalCertificateImage',
        filesToUpload.document?.get('files') ?? '',
      );
    }
    return fd;
  };

  const formik = useFormik<IVaccinationCertificateRequest>({
    initialValues: {
      document: {
        image: undefined,
        createdAt: undefined,
      },
    },
    validationSchema: validateVaccinationCertificate,
    enableReinitialize: true,
    onSubmit: async formValues => {
      if (saveLoading) return;
      setSaveLoading(true);
      if (formValues.document.image !== undefined) {
        const createdAt = getCurrentDate();
      }

      const payload = await buildPayloadMedCer(formValues);

      const res = await addressService.updateInfo(payload);

      // const response = await mutationVaccinationCertificate({
      //   ...formValues,
      //   status: 'submitted',
      // });

      const uploadImageErrors = [];

      // if (isAllowConsent && imageDeletionFiles.length > 0) {
      //   const imageDeleteFiles = await updateByFiles(imageDeletionFiles);
      //   if (imageDeleteFiles.error) uploadImageErrors.push(imageDeleteFiles);
      // }

      // if (res?. === STATUS_RESPONSE.UNAUTHORIZED) {
      //   await authenticationService.logout();
      //   goToLoginPage();
      // }

      if (res?.errorMessageList) {
        // transformMutationResponseError(res?.payload as any);
      }

      if (res?.success === true) {
        message.success('บันทึกข้อมูลเรียบร้อยแล้ว');
        goToMainPage();
        setSaveLoading(true);
      }
    },
  });

  useEffect(() => {
    const { dirty, isSubmitting } = formik;
    const isDirty = !isSubmitting && dirty;
    setFormDirty(isDirty);

    setIsShowModal(isDirty);

    setShowPrompt(isDirty);

    setCheckedBox(formik?.values?.document?.isAllowConsent ?? false);

    if (
      formik.values.document.isAllowConsent &&
      !formik.values.document.image
    ) {
      setDisabledSubmit(true);
    }

    if (!checkedBox || formik.values.document.image) {
      setDisabledSubmit(false);
    }

    // if (shouldDisableEdit(vaccinationCertificate)) {
    //   setDisabledSubmit(true);
    // }
  }, [formik]);

  const getInfo = async () => {
    try {
      const response = await mainService.getInfo();
      // const response = mainService.getMockPotentialLead(id);
      if (response.data.potentialLeadMedicalCertificate) {
        const infoData = response.data.potentialLeadMedicalCertificate;
        setIsApproved(infoData.statusCode === 'approved');

        if (infoData?.medicalCertificateImage) {
          const image = await loadImage(infoData?.medicalCertificateImage);
          setMedicalFileName(infoData.medicalCertificateImage);
          formik.setFieldValue('document', {
            image: image ? image.url : undefined,
          });
        }
      }
    } catch (e) {
      console.log('===== Debug error status: ', e.toString());
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  const errors = formik.errors || {};

  const handleUnauthorized = useCallback(async status => {
    if (status === STATUS_RESPONSE.UNAUTHORIZED) {
      await authenticationService.logout();
      goToMainPage();
    }
  }, []);

  const handleRemoveImage = useCallback(
    (file: UploadFile) => {
      if (!file.fileName?.match(/^blob\:/)) {
        setImageDeletionFiles([...imageDeletionFiles, file]);
      }
    },
    [imageDeletionFiles],
  );

  // if (
  //   getVaccinationCertificateError &&
  //   getVaccinationCertificateStatus !== STATUS_RESPONSE.UNAUTHORIZED
  // )
  //   return <ErrorPage />;

  const handleOnChecked = (event: any) => {
    setConsentModal(undefined);
    setCheckedBox(event.target.checked);
    formik.setFieldValue('document.isAllowConsent', event.target.checked);
  };

  const handleCloseModal = () => {
    setConsentModal(false);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <HeaderPortal formik={formik as FormikProps<FormikValues>} />
      <DriverPortalLayout>
        <ReturnButton />
        <Information
          title="ใบรับรองแพทย์"
          description='กรุณากรอกข้อมูล และอัพโหลดเอกสารที่มีเครื่องหมาย * ให้ครบถ้วน แล้วกด"บันทึก"'
        />

        <Divider />

        <FormItem
          required
          labelCol={{ span: 24 }}
          colon={false}
          validateStatus={errors.document?.image ? 'error' : ''}
          help={errors?.document?.image}
        >
          <UploadImageForm
            disabled={disableEdit || isApproved}
            title="อัพโหลดใบรับรองแพทย์"
            required
            bulletList={['ไม่แก้ไขและตกแต่งรูป', 'เห็นข้อมูลชัดเจนและครบถ้วน']}
            onChange={value => {
              const file = value.uploadFileForm?.get('files') as
                | File
                | undefined;

              setFilesToUpload({
                ...filesToUpload,
                document: value.uploadFileForm,
              });

              setMedicalFileName(file?.name || '');

              formik.setFieldValue('document', {
                image: file ? URL.createObjectURL(file) : undefined,
              });
            }}
            pathImage={formik.values.document.image}
            nameImage="ใบรับรองแพทย์"
            onRemove={file => {
              handleRemoveImage(file);
              setMedicalFileName('');
            }}
            folder={folderType}
            isPdf={isPdfFile(medicalFileName)}
            fileName={medicalFileName}
          />
        </FormItem>

        <Divider />

        <Button
          block
          type={disabledSubmit || isApproved ? 'default' : 'primary'}
          size="large"
          disabled={disabledSubmit || isApproved}
          htmlType="submit"
          loading={saveLoading}
        >
          บันทึก
        </Button>
      </DriverPortalLayout>
      {formDirty && <ConfirmReturnModal isShow={isShowModal} />}
    </form>
  );
};

export default VaccinationCertificatePage;
